import { CdkScrollable } from '@angular/cdk/scrolling';
import { DatePipe } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { BASE_URL_ENV_CONSTANTS } from '@app/core/constants';
import { SEX_VALUES, TIME_SLOTS_VALUES } from '@app/shared/constants';
import { TELEHEALTH_LANGUAGES_VALUES } from '@app/shared/constants/telehealth-language.constants';
import { Sex, TelehealthLanguage, TimeSlot } from '@app/shared/enums';
import { IRequestContactInfoDto } from '@app/shared/models/api/teladoc/irequest-contact-info-dto';
import { EnviromentZone, GENERAL_CONSTANTS, IHowdenEnvironment, LabelValueComponent } from '@howdeniberia/core-front';

@Component({
  selector: 'howden-readable-info-dialog',
  templateUrl: './readable-info-dialog.component.html',
  styleUrls: ['./readable-info-dialog.component.scss'],
  imports: [
    CdkScrollable,
    MatDialogTitle,
    MatDialogContent,
    MatDivider,
    MatTooltip,
    MatDialogActions,
    MatButton,
    MatIcon,
    DatePipe,
    LabelValueComponent
  ]
})
export class ReadableInfoDialogComponent implements OnInit {
  protected data = inject<IRequestContactInfoDto>(MAT_DIALOG_DATA);
  private howdenEnviroment = inject<IHowdenEnvironment>(GENERAL_CONSTANTS.EnvironmentInjectionToken);

  dialogRef = inject<MatDialogRef<ReadableInfoDialogComponent>>(MatDialogRef);

  baseUrl: string;

  ngOnInit(): void {
    switch (this.howdenEnviroment.zone) {
      case EnviromentZone.DEVELOPMENT:
        this.baseUrl = BASE_URL_ENV_CONSTANTS.development ?? '';
        break;
      case EnviromentZone.STAGING:
        this.baseUrl = BASE_URL_ENV_CONSTANTS.staging ?? '';
        break;
      case EnviromentZone.PRODUCTION:
        this.baseUrl = BASE_URL_ENV_CONSTANTS.production ?? '';
        break;
      default:
        this.baseUrl = BASE_URL_ENV_CONSTANTS.local ?? ''; //Nunca puede ser null
        break;
    }
  }

  getLanguageDesc(langId: TelehealthLanguage): string {
    return TELEHEALTH_LANGUAGES_VALUES.find(x=> x.key === langId)?.value ?? '';
  }

  getSexDesc(sexId: Sex): string {
    return SEX_VALUES.find(x=> x.key === sexId)?.value ?? '';
  }

  getTimeSlotDesc(timeSlotId: TimeSlot | null): string {
    if (timeSlotId === null) {
      return '';
    }
    return TIME_SLOTS_VALUES.find(x=> x.key === timeSlotId)?.value ?? '';
  }

  readCompanies(): Array<string> {
    const result: Array<string> = [];
    const capitals = this.data.capitals.split(';');
    this.data.companies.split(';').forEach((value, index) => {
      result.push(`${value} (${capitals[index]})`);
    });
    return result;
  }

  readNameFromEmailInfo(value: string): string {
    if (value === '') {
      return '';
    }
    const name = value.split(' <')[0];
    return name;
  }

  readEmailFromEmailInfo(value: string): string {
    if (value === '') {
      return '';
    }
    const email = value.split('<')[1].replace('>', '');
    return email;
  }

  close(): void {
    this.dialogRef.close();
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  mailTo(to: string): void {
    // Empty
  }
}
